module.exports = __webpack_public_path__ + "sx12-c1bec84d.png";